/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { GlobalState } from '../actions';

export const userGroupListSelector = (state: GlobalState) => state.userGroupList;

export const userGroupListEntitiesSelector = (state: GlobalState) => userGroupListSelector(state).userGroups;

export const userGroupListCountSelector = (state: GlobalState) => userGroupListSelector(state).count;

export const userGroupListSearchStringSelector = (state: GlobalState) => userGroupListSelector(state).searchString;

export const userGroupListCurrentPosSelector = (state: GlobalState) => userGroupListSelector(state).startPos;

export const userGroupListPageSizeSelector = (state: GlobalState) => userGroupListSelector(state).slotSize;
export const userGroupListIsLoadingSelector = (state: GlobalState) => userGroupListSelector(state).isLoading;
